import React from "react";
import Box from "@mui/material/Box";

// Shared Patient Portal page frame (Benefits Summary, Home).
const PageFrame = ({ children }: { children: React.ReactNode }) => (
  <Box sx={{ px: { xs: 2, md: 4 }, pt: { xs: 2, md: 4 }, maxWidth: 1200, mx: "auto" }}>
    {children}
  </Box>
);

export default PageFrame;
